module.exports = __webpack_public_path__ + "img/secret_histoire_vol24.9e445d58.jpg";